<template>
  <div class="input-group mb-3 home-subscribe" :class="hiw?'home-subscribe-wide':'home-subscribe-ib'">
    <b-input-group class="mt-3">
    <b-button v-if="!$auth.isAuthenticated" class="btn get-started-btn" to="/register" variant="primary">{{ $t('getstarted.getStarted') }}</b-button>
    <b-button v-if="$auth.isAuthenticated" class="btn get-started-btn" to="/invest" variant="primary">{{ $t('getstarted.startInvesting') }}</b-button>
      <router-link v-if="hiw" class="hiw" :to="$t('router.links.howItWorks')">{{ $t('getstarted.howItWorks') }}</router-link>
    </b-input-group>
  </div>
</template>

<script type="text/javascript" src="//marketing.getincome.com/form/generate.js?id=1"></script>
<script>
export default {
  name: 'GetStarted',
  props: ['hiw'],
  data()
  {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.home-subscribe-ib {
  display: inline-block;

  .get-started-btn {
    width: 100% !important;
    transition: color 0.2s ease-in-out, background-color 0.3s ease-in-out, border-color 0.3s ease-in-out, box-shadow 0.2s ease-in-out;
    &:hover{
      background: #3A4045;
      border-color: #3A4045 !important;
    }
  }
}

.home-subscribe {
  max-width: 420px;
  text-align: center;
  margin: 24px auto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  display: inline-block;

  .form-control {
    background: #FFFFFF;
    border: 2px solid #DFE1E6;
    box-sizing: border-box;
    border-radius: 24px;
    height: 48px;
  }

  .btn {
    background: #30A7FE;
    border-radius: 24px;
    color: #FFFFFF;
  }

  .get-started-btn {
    width: 67%;
    padding: 10px 12px;
  }
}

.home-subscribe-wide {
  max-width: 566px;

  .input-group {
    align-items: center;
  }

  .hiw {
    margin-left: 10px;
    height: 48px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    padding: 0.65rem 0.65rem !important;
    text-align: center;
    color: #30A7FE;
  }
}

@media only screen and (max-width: 1024px) {
  .home-subscribe-wide {
    text-align: center;
    display: inline-flex;

    .hiw {
      margin-left: 8px;
    }
  }
}

@media only screen and (max-width: 585px) {
  form, .mt-3, .hiw, .get-started-btn {
    width: 100% !important;
    margin-bottom: 5px;
  }
}
</style>
